/* eslint-disable @typescript-eslint/no-non-null-assertion */
import Vue from 'vue'
import App from './app.vue'
import router from './router'
import VueCompositionApi, {onMounted} from '@vue/composition-api';
import Vuex from 'vuex';
import {i18n, loadUserLanguageOrDefault} from '@/utilities/vue-i18n';
import 'overlayscrollbars/css/OverlayScrollbars.css';
import {OverlayScrollbarsPlugin} from 'overlayscrollbars-vue';
import VueDragscroll from 'vue-dragscroll';
import VueForceNextTick from 'vue-force-next-tick';
import {initiateExternalAuthentication, watchToken} from './functions/authentication-functions';
import {populateStates, registerStateProviders} from "@/states/state-registration";
import VueRouterReferer from '@tozd/vue-router-referer';
import {DateFormat} from './filters/date-filter';
import VSwitch from 'v-switch-case';
import smoothscroll from 'smoothscroll-polyfill';
import {refineSizing} from "@/functions/sizing-functions";
import AppDisabled from '@/directives/app-disabled';
import 'vue-virtual-scroller/dist/vue-virtual-scroller.css';
import './styles.scss';
import InputFocus from './directives/app-input-focus';

if ((window as unknown as {unsupportedBrowser: true | undefined}).unsupportedBrowser !== true)
{
    (window as unknown as {__forceSmoothScrollPolyfill__: boolean}).__forceSmoothScrollPolyfill__ = true;

    Vue.config.productionTip = false;

    Vue.filter('dateFormat', DateFormat);

    Vue.use(VueDragscroll);

    Vue.use(OverlayScrollbarsPlugin);

    Vue.use(VueCompositionApi);

    Vue.use(Vuex);

    Vue.use(VueForceNextTick);

    Vue.use(VueRouterReferer);

    Vue.use(VSwitch);

    Vue.directive(AppDisabled.Name, AppDisabled.Directive);

    Vue.directive(InputFocus.Name, InputFocus.Directive);

    smoothscroll.polyfill();

    refineSizing();

    window.addEventListener("resize", refineSizing);

    if ('serviceWorker' in navigator) {

      window.addEventListener('load', function () {
        navigator.serviceWorker.register('/version-service-worker.js').then(registration => {
          
          console.log('Version service worker registration successful with scope: ', registration.scope, ' --- Date: ', new Date());
          
          registration.update();

          if (registration.active) {
              // Post a message to the service worker
              registration.active.postMessage('Test push message from main JavaScript!');

              setInterval(() => {
                  registration.active!.postMessage('Test push message from main JavaScript!');
              }, 5 * 60 * 1000); // 5 minutes
          }

      }, function (err) {
          console.log('Version service worker registration failed: ', err);

        });
      });
      
    }

    (async function main() {

        await initiateExternalAuthentication();

        await loadUserLanguageOrDefault();

        new Vue({

            router,

            i18n,

            setup() {

                registerStateProviders();

                onMounted(() => populateStates());
            },

            render: h => h(App)

        }).$mount('#app');

        watchToken();

    })();
}
